import {ChecklistProcess, MaterialType} from "./types/dtoTypes";

export interface DropdownItem {
  label: string;
  value: string;
}

export const VISA_PROCESS: ChecklistProcess = {
  code: 'VISA',
  titleKey: 'process.visum',
  items: [
    { key: 'visa.cv',                     label: 'CV',                               requiredTypes: MaterialType.CV },
    { key: 'visa.passport',               label: 'Passport',                         requiredTypes: MaterialType.PASSPORT },
    { key: 'visa.germanCert',             label: 'German Language Certificate B2',   requiredTypes: MaterialType.GERMAN_CERTIFICATE },
    { key: 'visa.highSchool',             label: 'High School Diploma',              requiredTypes: MaterialType.HIGH_SCHOOL_DIPLOMA, optional: true },
    { key: 'visa.universityDiploma',      label: 'University Diploma',               requiredTypes: MaterialType.UNIVERSITY_DIPLOMA },
    { key: 'visa.defizit',                label: 'Defizitbescheid',                  requiredTypes: MaterialType.DEFICIT_BESCHEID },
    { key: 'visa.anerkennung',            label: 'Anerkennung',                      requiredTypes: MaterialType.ANERKENNUNG },
    { key: 'visa.jobContract',            label: 'Employment contract',              requiredTypes: MaterialType.JOB_CONTRACT },
  ],
};


export const PHYSIO_RECOGNITION_DOCS_PROCESS: ChecklistProcess = {
  code: 'PHYSIO_RECOGNITION_DOCS',
  titleKey: 'process.physioDocs.title',
  items: [
    { key: 'physio.degree', label: 'Qualification and degree', requiredTypes: MaterialType.UNIVERSITY_DIPLOMA },
    { key: 'physio.cv', label: 'CV', requiredTypes: MaterialType.CV },
    { key: 'physio.passport', label: 'Passport copy', requiredTypes: MaterialType.PASSPORT },
    { key: 'physio.germanB1', label: 'At least B1 certificate', requiredTypes: MaterialType.GERMAN_CERTIFICATE },
    { key: 'physio.goodStanding', label: 'Certificate of Good Standing', requiredTypes: MaterialType.GOOD_STANDING_CERTIFICATE },
    { key: 'physio.hepatitis', label: 'Hepatitis vaccination', requiredTypes: MaterialType.HEPATITIS_VACCINATION },
    { key: 'physio.measlesVacc', label: 'Measles vaccination', requiredTypes: MaterialType.MEASLES_VACCINATION },
    { key: 'physio.measlesTiter', label: 'Measles titer lab result (alternative)', requiredTypes: MaterialType.MEASLES_TITER_LAB, optional: true },
  ],
};

export const CONTRACT_TYPES: DropdownItem[] = [
  { label: 'Full-time', value: 'Full-time' },
  { label: 'Part-time', value: 'Part-time' },
  { label: 'Internship', value: 'Internship' },
  { label: 'Freelance', value: 'Freelance' },
];
export const SALARY_RANGES: DropdownItem[] = [
  { label: '< 1000€', value: '< 1000€' },
  { label: '1000€ - 2000€', value: '1000€ - 2000€' },
  { label: '2000€ - 3000€', value: '2000€ - 3000€' },
  { label: '> 3000€', value: '> 3000€' },
];

export const PROFILES_COUNT_OPTIONS: DropdownItem[] = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' }
];

export const GERMAN_LEVELS: DropdownItem[] = [
  { label: 'None', value: 'None' },
  { label: 'A1', value: 'A1' },
  { label: 'A2', value: 'A2' },
  { label: 'B1', value: 'B1' },
  { label: 'B2', value: 'B2' },
  { label: 'C1', value: 'C1' },
  { label: 'C2', value: 'C2' },
];

export const EXPERIENCES: DropdownItem[] = [
  { label: 'No experience', value: 'No experience' },
  { label: '1 - 2 years', value: '1 - 2 years' },
  { label: '2 - 3 years', value: '2 - 3 years' },
  { label: '3+ years', value: '3+ years' },
];

export const EDUCATION_LEVELS: DropdownItem[] = [
  { label: 'No requirement', value: 'No requirement' },
  { label: 'High School', value: 'High School' },
  { label: 'Bachelor', value: 'Bachelor' },
  { label: 'Master', value: 'Master' },
  { label: 'PhD', value: 'PhD' },
];

export const PROFILE_COUNTS: DropdownItem[] = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const COURSES = [
  "YOGA",
  "GYM",
  "ENTREPREUNEURSHIP",
  "MENTAL HEALTH",
  "MUSIC",
  "PAINTING",
  "DATING"
]

export const PATH = {
  "LOGIN": "/login",
  "CREATE_JOB_POST": "/create-job-offer",
  "REGISTER": "/register",
  "CREATE_SESSION": "/createSession",
  "MAIN": "/main",
  "COMPANY_DASHBOARD": "/companyDashboard",
  "CANDIDATE_OVERVIEW": "/candidate-overview",
  "ADMIN_DASHBOARD": "/adminDashboard",
  "AGENCY_DASHBOARD": "/agencyDashboard",
  "JOBS": "/jobs",
  "PROFIL": "/profile/",
  "CHAT": "/chat/",
  "REVIEWS": "/reviews/",
  "APPLICATIONS_OVERVIEW": "/applications-overview/",
  "CERTIFICATES": "/certificates/",
  "BOOKINGS": "/bookings/",
  "SESSIONS": "/sessions/",
  "MESSAGES": "/messages/",
  "VIDEO": "/video",
  "FORGOT_PASSWORD": "/forgot-password",
  "PRICING": "/pricing",
}


export enum BOOKING_STATUS {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  FINISHED = 'FINISHED'
}


export enum CALL_TYPE {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}

export const VIDEO_TYPE = [
  "webm", "mpg", "mp2", "mpeg", "mpe", "mpv",
  "ogg", "mp4", "m4v", "avi", "wmv", "mov",
  "qt", "flv", "swf", "avchd"
];

export const termsOfService = `
<p><strong>Bipperz Terms of Service</strong></p>
<p><strong>Effective Date: 01.01.2024</strong></p>

<p>Welcome to Bipperz! We are committed to helping candidates find jobs and apprenticeships in Germany while connecting employers with qualified international talent. These Terms of Service ("Terms") govern your access and use of our platform, including our website, applications, and related services ("Platform"), owned and operated by Bipperz.</p>

<p><strong>1. Acceptance of Terms</strong></p>
<p>By accessing or using the Bipperz Platform, you agree to comply with these Terms and any other policies referenced herein, such as our Privacy Policy and Refund Policy. If you do not agree, please discontinue your use of the Platform.</p>

<p><strong>2. Services Provided</strong></p>
<p>Bipperz provides a recruitment platform that facilitates job placements and apprenticeships in Germany by connecting candidates with employers. Our services include job postings, candidate profile creation, employer-candidate matchmaking, application support, and visa guidance.</p>

<p><strong>3. Registration and Account Management</strong></p>
<p>- <strong>Eligibility:</strong> Candidates must be at least 18 years old to register and apply for jobs through Bipperz.</p>
<p>- <strong>Account Security:</strong> Users are responsible for safeguarding their account credentials. Notify Bipperz immediately if you suspect unauthorized access to your account.</p>
<p>- <strong>Profile Information:</strong> Candidates and employers must provide accurate and up-to-date information to ensure transparency and trust on the Platform.</p>

<p><strong>4. Code of Conduct</strong></p>
<p>- <strong>Professional Communication:</strong> All users must engage in respectful and professional interactions. Any form of harassment, discrimination, or abusive behavior is strictly prohibited.</p>
<p>- <strong>Compliance with Laws:</strong> Users must comply with all applicable local, national, and international labor laws when using the Platform.</p>

<p><strong>5. Job Applications and Hiring Process</strong></p>
<p>- <strong>Candidate Applications:</strong> Candidates may apply to available job opportunities through the Platform. Employers review applications and may conduct interviews.</p>
<p>- <strong>Employment Offers:</strong> Bipperz does not guarantee employment; hiring decisions are made solely by the employer.</p>
<p>- <strong>Visa and Work Permit Assistance:</strong> Bipperz provides guidance on visa and work permit applications but does not guarantee visa approvals.</p>

<p><strong>6. Payments and Fees</strong></p>
<p>- <strong>For Candidates:</strong> Certain premium services (such as language training, resume review, or visa application assistance) may require payment. Fees will be disclosed before purchase.</p>
<p>- <strong>For Employers:</strong> Employers may be required to pay a service fee for job postings and candidate placements.</p>

<p><strong>7. Limitation of Liability</strong></p>
<p>Bipperz is not responsible for the outcome of any hiring decision, employer actions, or employment conditions. We are not liable for indirect, incidental, or consequential damages arising from the use of our Platform.</p>

<p><strong>8. Changes to Terms</strong></p>
<p>Bipperz may update these Terms periodically. Users will be notified of significant changes, and continued use of the Platform constitutes acceptance of these modifications.</p>

<p><strong>9. Contact Information</strong></p>
<p>For any questions, please contact us at info@bipperz.com.</p>
`;


export const privacyPolicies = `
<p><strong>Bipperz Privacy Policy</strong></p>
<p><strong>Effective Date: 01.01.2024</strong></p>

<p>Bipperz is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share personal information.</p>

<p><strong>1. Information We Collect</strong></p>
<p>- <strong>Candidate Data:</strong> Name, email, resume, job preferences, and work experience.</p>
<p>- <strong>Employer Data:</strong> Company details, job listings, and hiring preferences.</p>
<p>- <strong>Payment Data:</strong> Payment details are securely processed via third-party providers.</p>

<p><strong>2. How We Use Your Information</strong></p>
<p>- <strong>For Recruitment Services:</strong> To connect candidates with employers.</p>
<p>- <strong>For Platform Improvements:</strong> To enhance the user experience and optimize services.</p>
<p>- <strong>For Legal and Compliance Purposes:</strong> To comply with applicable laws and regulations.</p>

<p><strong>3. Data Security</strong></p>
<p>We use encryption and security protocols to protect user data. However, no system is 100% secure.</p>

<p><strong>4. Your Rights</strong></p>
<p>- Users may access, correct, or delete their personal data.</p>
<p>- Users may opt out of marketing communications.</p>

<p><strong>5. Contact Information</strong></p>
<p>For privacy-related inquiries, contact info@bipperz.com.</p>
`;

export const impressium = `
<p><strong>Bipperz Legal Notice (Impressum)</strong></p>

<p><strong>Company Name:</strong> Bipperz UG</p>
<p><strong>Address:</strong> Innstraße 69b, 94032 Passau, Germany</p>
<p><strong>Contact:</strong> info@bipperz.com</p>
<p><strong>Business Registration:</strong> Handelsregister [Registration Number]</p>
<p><strong>VAT ID:</strong> [VAT Number]</p>

<p><strong>Disclaimer:</strong></p>
<p>Despite careful content control, we are not responsible for external links.</p>

<p><strong>Online Dispute Resolution:</strong></p>
<p>EU residents can access the dispute resolution platform at <a href="http://ec.europa.eu/consumers/odr">this link</a>.</p>
`;
